import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Payload = {
  category: uui.domain.ui.list.Category
  options?: (keyof uui.domain.ui.list.ListOptions)[]
}

/**
 * Reset the list options.
 *
 * @private
 */
export const resetListOptions = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('ui/listOptions/reset', async (payload, thunkApi) => {
  const { category, options } = payload
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/ui/resetListOptions', {
      category: 'rpc',
      type: 'rpc/ui/resetListOptions',
      params: { category, options },
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {resetListOptions}`,
      { tags: ['rpc', 'ui', 'listOptions'], info: { category, options } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Reset list options failed`,
      error,
    })
  }
})
